import { render, staticRenderFns } from "./MultipleChoiceCheckbox.vue?vue&type=template&id=b2e36012"
import script from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports